import _toConsumableArray from "/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { get } from '../get.js';
import { merge } from '../merge.js';
var REPLACE_REGEX = /{([^}]*)}/g;

var I18n = /*#__PURE__*/function () {
  /**
   * @param translation A locale object or array of locale objects that overrides default translations. If specifying an array then your desired language dictionary should come first, followed by your fallback language dictionaries
   */
  function I18n(translation) {
    _classCallCheck(this, I18n);

    this.translation = {}; // slice the array to make a shallow copy of it, so we don't accidentally
    // modify the original translation array

    this.translation = Array.isArray(translation) ? merge.apply(void 0, _toConsumableArray(translation.slice().reverse())) : translation;
  }

  _createClass(I18n, [{
    key: "translate",
    value: function translate(id, replacements) {
      var text = get(this.translation, id, '');

      if (!text) {
        return '';
      }

      if (replacements) {
        return text.replace(REPLACE_REGEX, function (match) {
          var replacement = match.substring(1, match.length - 1);

          if (replacements[replacement] === undefined) {
            var replacementData = JSON.stringify(replacements);
            throw new Error("Error in translation for key '".concat(id, "'. No replacement found for key '").concat(replacement, "'. The following replacements were passed: '").concat(replacementData, "'"));
          } // This could be a string or a number, but JS doesn't mind which it gets
          // and can handle that cast internally. So let it, to save us calling
          // toString() on what's already a string in 90% of cases.


          return replacements[replacement];
        });
      }

      return text;
    }
  }, {
    key: "translationKeyExists",
    value: function translationKeyExists(path) {
      return Boolean(get(this.translation, path));
    }
  }]);

  return I18n;
}();

export { I18n };